import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconPowerCable24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="power cable">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7 5V1C7 0.447715 7.44772 0 8 0C8.55228 0 9 0.447715 9 1V5H15V1C15 0.447715 15.4477 0 16 0C16.5523 0 17 0.447715 17 1V5H21C21.5523 5 22 5.44772 22 6C22 6.55228 21.5523 7 21 7H20V13C20 13.2652 19.8946 13.5196 19.7071 13.7071L17 16.4142V19C17 19.5523 16.5523 20 16 20H13V23C13 23.5523 12.5523 24 12 24C11.4477 24 11 23.5523 11 23V20H8C7.44772 20 7 19.5523 7 19V16.4142L4.29289 13.7071C4.10536 13.5196 4 13.2652 4 13V7H3C2.44772 7 2 6.55228 2 6C2 5.44772 2.44772 5 3 5H7ZM6 7V12.5858L8.70711 15.2929C8.89464 15.4804 9 15.7348 9 16V18H15V16C15 15.7348 15.1054 15.4804 15.2929 15.2929L18 12.5858V7H6Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconPowerCable48(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="power cable">
            <mask
                id="path-1-inside-1"
                fill={props.fill || 'currentColor'}>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20 4C20 2.34315 18.6569 1 17 1C15.3431 1 14 2.34315 14 4V13H20V4Z"
                />
            </mask>
            <path
                d="M14 13H12V15H14V13ZM20 13V15H22V13H20ZM17 3C17.5523 3 18 3.44772 18 4H22C22 1.23858 19.7614 -1 17 -1V3ZM16 4C16 3.44772 16.4477 3 17 3V-1C14.2386 -1 12 1.23858 12 4H16ZM16 13V4H12V13H16ZM20 11H14V15H20V11ZM18 4V13H22V4H18Z"
                fill={props.fill || 'currentColor'}
                mask="url(#path-1-inside-1)"
            />
            <mask
                id="path-3-inside-2"
                fill={props.fill || 'currentColor'}>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M34 4C34 2.34315 32.6569 1 31 1C29.3431 1 28 2.34315 28 4V13H34V4Z"
                />
            </mask>
            <path
                d="M28 13H26V15H28V13ZM34 13V15H36V13H34ZM31 3C31.5523 3 32 3.44772 32 4H36C36 1.23858 33.7614 -1 31 -1V3ZM30 4C30 3.44772 30.4477 3 31 3V-1C28.2386 -1 26 1.23858 26 4H30ZM30 13V4H26V13H30ZM34 11H28V15H34V11ZM32 4V13H36V4H32Z"
                fill={props.fill || 'currentColor'}
                mask="url(#path-3-inside-2)"
            />
            <mask
                id="path-5-inside-3"
                fill={props.fill || 'currentColor'}>
                <rect
                    x="6"
                    y="11"
                    width="36"
                    height="6"
                    rx="1"
                />
            </mask>
            <rect
                x="6"
                y="11"
                width="36"
                height="6"
                rx="1"
                stroke={props.stroke || 'currentColor'}
                strokeWidth="4"
                strokeLinejoin="round"
                mask="url(#path-5-inside-3)"
            />
            <mask
                id="path-6-inside-4"
                fill={props.fill || 'currentColor'}>
                <path d="M8 16C8 15.4477 8.44772 15 9 15H39C39.5523 15 40 15.4477 40 16V29.4176C40 29.7176 39.8654 30.0017 39.6332 30.1916L32.9001 35.6999C32.668 35.8899 32.5333 36.174 32.5333 36.4739V41C32.5333 41.5523 32.0856 42 31.5333 42H16.4667C15.9144 42 15.4667 41.5523 15.4667 41V36.4739C15.4667 36.174 15.332 35.8898 15.0999 35.6999L8.3668 30.1916C8.13464 30.0017 8 29.7176 8 29.4176V16Z" />
            </mask>
            <path
                d="M32.9001 35.6999L34.1665 37.2479L32.9001 35.6999ZM15.0999 35.6999L13.8335 37.2479L15.0999 35.6999ZM8.3668 30.1916L9.6332 28.6436L8.3668 30.1916ZM39.6332 30.1916L38.3668 28.6436L39.6332 30.1916ZM9 17H39V13H9V17ZM38 16V29.4176H42V16H38ZM10 29.4176V16H6V29.4176H10ZM16.3663 34.1519L9.6332 28.6436L7.1004 31.7396L13.8335 37.2479L16.3663 34.1519ZM38.3668 28.6436L31.6337 34.1519L34.1665 37.2479L40.8996 31.7396L38.3668 28.6436ZM17.4667 41V36.4739H13.4667V41H17.4667ZM30.5333 36.4739V41H34.5333V36.4739H30.5333ZM31.5333 40H16.4667V44H31.5333V40ZM30.5333 41C30.5333 40.4477 30.981 40 31.5333 40V44C33.1902 44 34.5333 42.6569 34.5333 41H30.5333ZM13.4667 41C13.4667 42.6569 14.8098 44 16.4667 44V40C17.019 40 17.4667 40.4477 17.4667 41H13.4667ZM31.6337 34.1519C30.9373 34.7217 30.5333 35.5741 30.5333 36.4739H34.5333C34.5333 36.7739 34.3987 37.058 34.1665 37.2479L31.6337 34.1519ZM13.8335 37.2479C13.6013 37.058 13.4667 36.7739 13.4667 36.4739H17.4667C17.4667 35.5741 17.0627 34.7217 16.3663 34.1519L13.8335 37.2479ZM6 29.4176C6 30.3175 6.40392 31.1698 7.1004 31.7396L9.6332 28.6436C9.86536 28.8336 10 29.1177 10 29.4176H6ZM38 29.4176C38 29.1177 38.1346 28.8336 38.3668 28.6436L40.8996 31.7396C41.5961 31.1698 42 30.3175 42 29.4176H38ZM39 17C38.4477 17 38 16.5523 38 16H42C42 14.3431 40.6569 13 39 13V17ZM9 13C7.34315 13 6 14.3431 6 16H10C10 16.5523 9.55228 17 9 17V13Z"
                fill={props.fill || 'currentColor'}
                mask="url(#path-6-inside-4)"
            />
            <path
                d="M25 20H26C26 19.5518 25.7018 19.1583 25.2702 19.0372C24.8387 18.9161 24.3793 19.0969 24.1461 19.4796L25 20ZM25 26.1538H24C24 26.7061 24.4477 27.1538 25 27.1538V26.1538ZM19 29.8462L18.1461 29.3258C17.9579 29.6345 17.9511 30.0207 18.1281 30.3359C18.3051 30.651 18.6385 30.8462 19 30.8462V29.8462ZM23 29.8462H24C24 29.5809 23.8946 29.3266 23.7071 29.139C23.5196 28.9515 23.2652 28.8462 23 28.8462V29.8462ZM23 36H22C22 36.4482 22.2982 36.8417 22.7298 36.9628C23.1613 37.0839 23.6207 36.9031 23.8539 36.5204L23 36ZM29 26.1538L29.8539 26.6742C30.0421 26.3655 30.0489 25.9793 29.8719 25.6641C29.6949 25.349 29.3615 25.1538 29 25.1538V26.1538ZM24 20V26.1538H26V20H24ZM19.8539 30.3665L25.8539 20.5204L24.1461 19.4796L18.1461 29.3258L19.8539 30.3665ZM23 28.8462H19V30.8462H23V28.8462ZM24 36L24 29.8462H22L22 36H24ZM28.1461 25.6335L22.1461 35.4796L23.8539 36.5204L29.8539 26.6742L28.1461 25.6335ZM25 27.1538L29 27.1538V25.1538L25 25.1538V27.1538Z"
                fill={props.fill || 'currentColor'}
            />
            <rect
                x="21"
                y="41"
                width="6"
                height="5"
                stroke={props.stroke || 'currentColor'}
                strokeWidth="2"
                strokeLinejoin="round"
            />
        </svg>
    );
}
